import translations from "./translations.json";

export const translate = (term: keyof typeof translations, locale?: string) => {
  return (translations as any)[term][locale ?? "ru"];
};
